
const m = window.requirejs;
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
